import { declensionFactory } from '@helpers/declension';

const declineHours = declensionFactory('час', 'часа', 'часов');
const declineMinutes = declensionFactory('минута', 'минуты', 'минут');

export const stringFromMinutes = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const minutesRemainder = minutes % 60;
  const result = [];

  if (hours > 0) {
    result.push(hours + ' ' + declineHours(hours));
  }

  if (minutesRemainder > 0 || hours === 0) {
    result.push(minutesRemainder + ' ' + declineMinutes(minutesRemainder));
  }

  return result.join(' ');
};
